import { render, staticRenderFns } from "./ModalAcountFix.vue?vue&type=template&id=2a4928bf&"
import script from "./ModalAcountFix.vue?vue&type=script&lang=js&"
export * from "./ModalAcountFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports